// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"9d1d6e19","825":"ab94c4e1"}[chunkId] + ".chunk.css";
};